import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeLogoSkeleton } from "./TypeLogo";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeLogoSection'
 * @name TypeLogoSectionFields
 * @type {TypeLogoSectionFields}
 * @memberof TypeLogoSection
 */
export interface TypeLogoSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized true
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'logos' (Logos)
     * @name Logos
     * @localized false
     */
    logos?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeLogoSkeleton>>;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'logoSection' (Logo Section)
 * @name TypeLogoSectionSkeleton
 * @type {TypeLogoSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T20:20:10.643Z
 * @version 30
 */
export type TypeLogoSectionSkeleton = EntrySkeletonType<TypeLogoSectionFields, "logoSection">;
/**
 * Entry type definition for content type 'logoSection' (Logo Section)
 * @name TypeLogoSection
 * @type {TypeLogoSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-23T20:20:10.643Z
 * @version 30
 */
export type TypeLogoSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLogoSectionSkeleton, Modifiers, Locales>;

export function isTypeLogoSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLogoSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'logoSection'
}
